import { Toggle } from "@frends/ui-components/react";

export default Toggle;
